import { InputNumber } from "antd";

const cleanupDecimal = (value = "") => {
  let v = value.replace(/,/g, ".");

  v = v.replace(/[^\d.]/g, "");

  const parts = v.split(".");

  if (parts.length > 2) {
    v = parts[0] + "." + parts.slice(1).join("");
  }

  const [intPart, decPart] = v.split(".");
  if (decPart && decPart.length > 2) {
    v = intPart + "." + decPart.slice(0, 2);
  }
  return v;
};

const NumberInput = ({
  value,
  onChange,
  precision = 2,
  min = 0,
  max,
  ...rest
}) => {
  const numericValue = Number(String(value ?? "").replace(",", "."));
  const isOutOfRange =
    value !== null &&
    value !== undefined &&
    value !== "" &&
    ((!Number.isNaN(numericValue) && numericValue < min) ||
      (max !== undefined && numericValue > max));

  const handleBlur = () => {
    if (value === undefined || value === null || value === "") return;
    if (isOutOfRange) return;

    const num =
      typeof value === "number"
        ? value
        : Number(String(value).replace(",", "."));

    if (Number.isNaN(num)) return;

    const fixed = Number(num.toFixed(precision));
    onChange?.(fixed);
  };

  return (
    <InputNumber
      {...rest}
      value={value}
      status={isOutOfRange ? "error" : rest.status}
      stringMode
      inputMode="decimal"
      parser={(v) => (v ? cleanupDecimal(v) : "")}
      onChange={onChange}
      onBlur={handleBlur}
    />
  );
};

export default NumberInput;
